import { createSlice } from "@reduxjs/toolkit";
import {
  getOrdersBuilder,
  getOrderByIdBuilder,
  createOrderBuilder,
  updateOrderStatusBuilder,
  deleteOrderBuilder,
} from "./builder";

const initialState = {
  orders: {
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
      totalOrders: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      limit: 12,
    },
    totalRevenue: 0,
    thisMonthRevenue: 0,
    lastMonthRevenue: 0,
    loading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    createSuccess: false,
    error: null,
  },

  orderById: {
    data: null,
    loading: false,
    error: null,
  },
};

export const ordersSlice = createSlice({
  name: "ordersInfo",
  initialState,
  reducers: {
    // Synchronous actions
    clearOrderById: (state) => {
      state.orderById.data = null;
      state.orderById.error = null;
    },
    clearOrdersError: (state) => {
      state.orders.error = null;
    },
    clearCreateSuccess: (state) => {
      state.orders.createSuccess = false;
    },
    resetOrdersState: (state) => {
      state.orders = initialState.orders;
      state.orderById = initialState.orderById;
    },
  },

  extraReducers: (builder) => {
    // Async thunks
    getOrdersBuilder(builder);
    getOrderByIdBuilder(builder);
    createOrderBuilder(builder);
    updateOrderStatusBuilder(builder);
    deleteOrderBuilder(builder);

    // Handle logout - clear all data
    builder.addCase("auth/logout", (state) => {
      state.orders = initialState.orders;
      state.orderById = initialState.orderById;
    });
  },
});

// Export synchronous actions
export const {
  clearOrderById,
  clearOrdersError,
  clearCreateSuccess,
  resetOrdersState,
} = ordersSlice.actions;

// Selectors
export const selectOrders = (state) => state.ordersInfo.orders;
export const selectOrderById = (state) => state.ordersInfo.orderById;

// Advanced selectors
export const selectPendingOrders = (state) => ({
  ...state.ordersInfo.orders,
  data: state.ordersInfo.orders.data.filter(
    (order) => order.status === "pending"
  ),
});

export const selectCompletedOrders = (state) => ({
  ...state.orders.orders,
  data: state.orders.orders.data.filter(
    (order) => order.status === "completed"
  ),
});

export default ordersSlice.reducer;
